/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Lastmodifiedoffers_Title2Inputs */

const id_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran yang Terakhir Dimodifikasi`)
};

const ms_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran Diubah Suai Terakhir`)
};

const da_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidst Ændrede Tilbud`)
};

const de_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuletzt geänderte Angebote`)
};

const en_us2_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Modified Offers`)
};

const es_es2_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas ofertas modificadas`)
};

const es_mx2_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas modificadas recientemente`)
};

const fil_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Huling Binagong Offer`)
};

const fr_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres récemment modifiées`)
};

const it_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultime offerte modificate`)
};

const hu_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utoljára módosított ajánlatok`)
};

const nl_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatst gewijzigde aanbiedingen`)
};

const no_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sist endrede tilbud`)
};

const pl_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnio modyfikowane oferty`)
};

const pt_br2_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Modified Offers`)
};

const pt_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas modificadas recentemente`)
};

const ro_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte modificate recent`)
};

const fi_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeksi muokatut tarjoukset`)
};

const sv_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senast ändrade erbjudanden`)
};

const vi_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi sửa đổi lần cuối`)
};

const tr_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Değiştirilen Teklifler`)
};

const cs_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naposledy změněné nabídky`)
};

const bg_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последно променени оферти`)
};

const ru_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние изменённые предложения`)
};

const uk_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останні змінені пропозиції`)
};

const ar_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر العروض المعدلة`)
};

const hi_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम संशोधित ऑफ़र`)
};

const th_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอที่แก้ไขล่าสุด`)
};

const ja_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新オファー`)
};

const zh_cn2_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Modified Offers`)
};

const zh_hant1_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Modified Offers`)
};

const ko_components_lastmodifiedoffers_title2 = /** @type {(inputs: Components_Lastmodifiedoffers_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Modified Offers`)
};

/**
* | output |
* | --- |
* | "Last Modified Offers" |
*
* @param {Components_Lastmodifiedoffers_Title2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_lastmodifiedoffers_title2 = /** @type {((inputs?: Components_Lastmodifiedoffers_Title2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Lastmodifiedoffers_Title2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_lastmodifiedoffers_title2(inputs)
	if (locale === "ms") return ms_components_lastmodifiedoffers_title2(inputs)
	if (locale === "da") return da_components_lastmodifiedoffers_title2(inputs)
	if (locale === "de") return de_components_lastmodifiedoffers_title2(inputs)
	if (locale === "en-US") return en_us2_components_lastmodifiedoffers_title2(inputs)
	if (locale === "es-ES") return es_es2_components_lastmodifiedoffers_title2(inputs)
	if (locale === "es-MX") return es_mx2_components_lastmodifiedoffers_title2(inputs)
	if (locale === "fil") return fil_components_lastmodifiedoffers_title2(inputs)
	if (locale === "fr") return fr_components_lastmodifiedoffers_title2(inputs)
	if (locale === "it") return it_components_lastmodifiedoffers_title2(inputs)
	if (locale === "hu") return hu_components_lastmodifiedoffers_title2(inputs)
	if (locale === "nl") return nl_components_lastmodifiedoffers_title2(inputs)
	if (locale === "no") return no_components_lastmodifiedoffers_title2(inputs)
	if (locale === "pl") return pl_components_lastmodifiedoffers_title2(inputs)
	if (locale === "pt-BR") return pt_br2_components_lastmodifiedoffers_title2(inputs)
	if (locale === "pt") return pt_components_lastmodifiedoffers_title2(inputs)
	if (locale === "ro") return ro_components_lastmodifiedoffers_title2(inputs)
	if (locale === "fi") return fi_components_lastmodifiedoffers_title2(inputs)
	if (locale === "sv") return sv_components_lastmodifiedoffers_title2(inputs)
	if (locale === "vi") return vi_components_lastmodifiedoffers_title2(inputs)
	if (locale === "tr") return tr_components_lastmodifiedoffers_title2(inputs)
	if (locale === "cs") return cs_components_lastmodifiedoffers_title2(inputs)
	if (locale === "bg") return bg_components_lastmodifiedoffers_title2(inputs)
	if (locale === "ru") return ru_components_lastmodifiedoffers_title2(inputs)
	if (locale === "uk") return uk_components_lastmodifiedoffers_title2(inputs)
	if (locale === "ar") return ar_components_lastmodifiedoffers_title2(inputs)
	if (locale === "hi") return hi_components_lastmodifiedoffers_title2(inputs)
	if (locale === "th") return th_components_lastmodifiedoffers_title2(inputs)
	if (locale === "ja") return ja_components_lastmodifiedoffers_title2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_lastmodifiedoffers_title2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_lastmodifiedoffers_title2(inputs)
	return ko_components_lastmodifiedoffers_title2(inputs)
});
export { components_lastmodifiedoffers_title2 as "components.lastModifiedOffers.title" }